export const SET_IDEAS_LOADING = 'SET_IDEAS_LOADING'
export const SET_IDEAS = 'SET_IDEAS'
export const ADD_IDEAS = 'ADD_IDEAS'
export const EDIT_IDEAS = 'EDIT_IDEAS'
export const DELETE_IDEAS = 'DELETE_IDEAS'